import * as Sentry from '@sentry/browser';
/**
 * @description ShowReportDialog opens bug report form with preset settings
 *
 */
export var ShowReportDialog = function (id) {
    Sentry.showReportDialog({
        eventId: id,
        successMessage: 'Спасибо, сообщение об ошибке успешно отправлено!',
    });
};
